import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Gets the Map Set settings
 * @returns Object containing Map Set settings
 */
export function getMapSetSettings(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyMapsetSettingsUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        maxMapSetAssignments: z.number(),
      })
    )
  );
}
